import { HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit, ViewChild } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { AccountingFirm } from '../../../models/accountingFirm.model';
import { Pages } from '../../../models/blog.model';
import { SquidexService } from '../../../services/squidex.service';
import { TranslateService } from '@ngx-translate/core'
import { BehaviorSubject, of, Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import * as accountingFirms from './content.json'
@Component({
  selector: 'flowaccount-find-accountingfirm',
  templateUrl: './find-accountingfirm.component.html',
  styleUrls: ['./find-accountingfirm.component.scss'],
})
export class FindAccountingfirmComponent implements OnInit {
  page = Pages
  json = []

  public langChangeSubscription: Subscription
  public recommendAccountingFirmList: BehaviorSubject<Array<AccountingFirm>> = new BehaviorSubject<
    Array<AccountingFirm>
  >([])
  public partnerAccountingFirmList: BehaviorSubject<Array<AccountingFirm>> = new BehaviorSubject<Array<AccountingFirm>>(
    [],
  )
  customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_BUSSINESSOWNER',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_BUSSINESSOWNER',
  }

  constructor(
    public translate: TranslateService,
    private titleService: Title,
    private seoService: SEOService,
    public readonly squidexService: SquidexService,
  ) { }  
  ngOnInit() {
    this.setMeta()
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event) => {
      this.setMeta()
    })

    // const y = await this.squidexService.getAccountingFirms().subscribe((data: AccountingFirm[]) => {
    //   this.recommendAccountingFirmList.next(data.filter((x) => x.isRecommend === true))
    //   this.partnerAccountingFirmList.next(data.filter((x) => x.isRecommend === false))
    // })
  }

  setMeta(): void {
    this.titleService.setTitle(this.translate.instant('metatitle-Accountingfirm'))
    this.seoService.createMetaTag(this.translate.instant('metatitle-Accountingfirm'), this.translate.instant('metaDescription'))
    this.seoService.createOg(
      'https://flowaccountcdn.com/images/Thumnail_FlowPayroll_FlowAccount.png',
      this.translate.instant('metatitle-Accountingfirm'),
      this.translate.instant('metaDescription'),
    )
  }

  ngOnDestroy(): void {
    this.langChangeSubscription.unsubscribe()
  }

  /* ใช้เรียกเพื่อ import ข้อมูลจาก json ไปยัง squidex */
  // insertData() {
  //   accountingFirms.xxx.forEach((row) => {
  //     this.squidexService
  //       .insertAccountingFirms(row, false)
  //       .pipe(take(1))
  //       .subscribe((response) => {
  //         //console.log(response)
  //       })
  //   })
  // }
}
